import { render, staticRenderFns } from "./CompetitionCarrousel.vue?vue&type=template&id=1d72ce16"
import script from "./CompetitionCarrousel.vue?vue&type=script&lang=js"
export * from "./CompetitionCarrousel.vue?vue&type=script&lang=js"
import style0 from "./CompetitionCarrousel.vue?vue&type=style&index=0&id=1d72ce16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports